import { useLang } from "@/context/LangContext";
import { useCurrency } from "@/context/CurrencyContext";
import { LANGUAGES } from "@/i18n";

export function LangCurrencySwitcher({ compact = false }) {
  const { lang, setLang } = useLang();
  const { currency, setCurrency, supported } = useCurrency();
  return (
    <div className="flex items-center gap-2">
      <select value={lang} onChange={(e) => setLang(e.target.value)} data-testid="language-switcher"
        className="rounded-lg border border-border bg-card px-2 py-1.5 text-xs font-medium outline-none focus:border-primary">
        {LANGUAGES.map((l) => <option key={l.code} value={l.code}>{compact ? l.code.toUpperCase() : `${l.flag} ${l.label}`}</option>)}
      </select>
      <select value={currency} onChange={(e) => setCurrency(e.target.value)} data-testid="currency-switcher"
        className="rounded-lg border border-border bg-card px-2 py-1.5 text-xs font-medium outline-none focus:border-primary">
        {supported.map((c) => <option key={c} value={c}>{c}</option>)}
      </select>
    </div>
  );
}
